import React from 'react';
import * as yup from 'yup';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { HookFormTextInput } from '@components/ReactHookFormFields/HookFormTextInput';
import { useCustomTranslations } from '@hooks/useCustomTranslations';
import { DisturbanceLocation } from '@models/api/Incident';
import { formatDateToPlainDateInTimeZone } from '@utils/date.utils';

import { IncidentFormWrapper } from '../IncidentFormWrapper';

import {
  DisturbanceReportFormBase,
  useDisturbanceReport,
} from './Disturbance.utils';
import { DisturbanceCommonForm } from './DisturbanceCommonForm';

interface OtherForm extends DisturbanceReportFormBase {
  realEstateAddress?: string;
}

export const DisturbanceOtherForm = (props: ParsedEntry<IWidget>) => {
  const { t } = useCustomTranslations(props.customTranslations);
  const { create, defaultInitialValues, defaultValidationSchema } =
    useDisturbanceReport();

  return (
    <IncidentFormWrapper<OtherForm>
      incidentKind="DisturbanceOther"
      defaultValues={{ ...defaultInitialValues, realEstateAddress: '' }}
      validationSchema={defaultValidationSchema.concat(
        yup.object().shape({
          realEstateAddress: yup.string(),
        })
      )}
      onSubmit={({ disturbanceTimes, ...values }) =>
        create({
          ...values,
          disturbanceLocation: DisturbanceLocation.OTHER,
          dateTime: disturbanceTimes.map((date) =>
            formatDateToPlainDateInTimeZone(date)
          ),
        })
      }
    >
      <HookFormTextInput
        name="realEstateAddress"
        label={{ type: 'static', value: t('realEstateSearchLabel') }}
      />

      <DisturbanceCommonForm {...props} />
    </IncidentFormWrapper>
  );
};
